// extracted by mini-css-extract-plugin
export default {"title":"NewBrandPage_title__YGtif","brand_container_first":"NewBrandPage_brand_container_first__PE2H3","button_container":"NewBrandPage_button_container__uWHW6"};